import { rgba } from 'polished';
import styled from 'styled-components';

export const Footer = styled('footer')`
    min-height: 7.2rem;
    padding: 0.8rem 2.4rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: sticky;
    left: 0;
    bottom: 0;
    box-shadow: 0 0.2rem 1.6rem ${({ theme }) => rgba(theme.colors.grey[400], 0.6)};
    @media (min-width: ${({ theme }) => theme.breakpoints.M.min}px) {
        padding: 1.2rem 4rem;
    }
`;
